import { render, staticRenderFns } from "./IdentityIntegrations.vue?vue&type=template&id=17e056c4&scoped=true&"
import script from "./IdentityIntegrations.vue?vue&type=script&lang=ts&"
export * from "./IdentityIntegrations.vue?vue&type=script&lang=ts&"
import style0 from "./IdentityIntegrations.vue?vue&type=style&index=0&id=17e056c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e056c4",
  null
  
)

export default component.exports